import React from "react";
import "./Systeminvoicepdftemplate.scss"; // We will create this file next

// This is a NAMED export, so it must be imported with { SystemInvoiceLayout }
export const Systeminvoicepdftemplate = ({ invoice, settings, companyDetails }) => {
  const { header, displayBankDetails, bankDetails } = settings;

  // Destructure props from companyDetails (company object)
  const {
    companyName,
    address,
    city,
    state,
    zip,
    gstin= "24AACCL0249H1ZU",
  } = companyDetails || {};

  // Destructure props from invoice object
  const {
    createdAt,
    invoiceNumber,
    items,
    clientName, // Assuming "Name" from your request maps to clientName
    sgstAmount,
    cgstAmount,
    igstAmount,
    sgstPercentage,
    cgstPercentage,
    igstPercentage,
    hsnCode,
    totalAmount,
  } = invoice || {};

  // Helper function to handle image URLs
  const getDisplayUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("data:")) return url;
    if (url.startsWith("http")) return url;
    if (url.startsWith("/static/") || url.startsWith("/assets/")) return url;
    return `${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${url}`;
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  return (
    <div className="invoice-pdf system-invoice-layout">
      {/* 1. HEADER: Simple Image (As you requested) */}
      <div className="simple-header req-pad">
        {header ? (
          <img
            src={getDisplayUrl(header)}
            alt="Header"
            className="invoice-header-image"
          />
        ) : (
          <p>Header not available</p>
        )}
      </div>

      {/* 2. TITLE */}
      <div className="invoice-title req-pad">
        <h1>PROFORMA INVOICE</h1>
      </div>

      {/* 3. INFO BOX: Single-Block Layout with your requested content */}
      <div className="single-block-info req-pad">
        <p>
          <strong>Date:</strong> {formatDate(createdAt)}
        </p>
        <p>
          <strong>Company Name:</strong> {companyName || "N/A"}
        </p>
        <p>
          <strong>Address:</strong> {address || "N/A"}
        </p>
        <p>
          <strong>State:</strong> {state || "N/A"}
          &nbsp;&nbsp;&nbsp;
          <strong>Pincode:</strong> {zip || "N/A"}
        </p>
        <p>
          <strong>Invoice No.:</strong> {invoiceNumber || "N/A"}
        </p>
      </div>

      {/* 4. ITEMS TABLE */}
      <table className="invoice-table system-invoice-table req-pad">
        <thead>
          <tr>
            <th>PACKAGE DESCRIPTION</th>
            <th>SET</th>
            <th>AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {(items || []).map((item, i) => (
            <React.Fragment key={i}>
              <tr>
                <td>
                  <strong>{item.name}</strong>
                  {item.description && (
                    <>
                      <br />
                      <span style={{ fontSize: "0.9em" }}>
                        {item.description}
                      </span>
                    </>
                  )}
                </td>
                <td>{item.qty || item.quantity || 1}</td>
                <td>Rs. {item.amount.toFixed(2)}/-</td>
              </tr>
            </React.Fragment>
          ))}

          {/* GST Row */}
          {(sgstAmount > 0 || cgstAmount > 0 || igstAmount > 0) && (
            <tr>
              <td>
                {gstin && (
                  <>
                    <strong>GSTIN:</strong> {gstin}
                    <br />
                  </>
                )}
                <strong>HSN CODE:</strong>  85238020
              </td>
              <td>
                {igstPercentage > 0 && `IGST: ${igstPercentage}%`}
                {sgstPercentage > 0 && `SGST: ${sgstPercentage}%`}
                {cgstPercentage > 0 && ` CGST: ${cgstPercentage}%`}
              </td>
              <td>
                Rs.{" "}
                {(
                  (igstAmount || 0) +
                  (sgstAmount || 0) +
                  (cgstAmount || 0)
                ).toFixed(2)}
                /-
              </td>
            </tr>
          )}

          {/* Grand Total Row */}
          <tr className="grand-total-row">
            <td colSpan="2" style={{ textAlign: "right" }}>
              <strong>GRAND TOTAL :</strong>
            </td>
            <td>
              <strong>Rs. {totalAmount ? totalAmount.toFixed(2) : "0.00"}/-</strong>
            </td>
          </tr>
        </tbody>
      </table>

      {/* 5. FOOTER */}
      <div className="simple-footer req-pad">
        {displayBankDetails && bankDetails && (
          <div className="bank-details-section">
            <p>
              Please make a payment of your invoice in favour of{" "}
              <strong>LEVONS TECHNOLOGIES PVT. LTD.</strong> only.
            </p>
            <p>
              <strong>NEFT Details-</strong> 
              <span dangerouslySetInnerHTML={{ __html: bankDetails }} />
            </p>
          </div>
        )}
        <div className="footer-message">
          <p className="system-generated-note">
            This is a system generated invoice
          </p>
        </div>
      </div>
    </div>
  );
};